import {BaseClient} from "../../baseclient";
import {AuthzQueryExtension, AuthzQueryExtensionMethods} from "./query";
import {AuthzTxExtension, AuthzTxExtensionMethods} from "./tx";

export type AuthzExtension = AuthzQueryExtension & AuthzTxExtension;
export type AuthzExtensionMethods = AuthzQueryExtensionMethods & AuthzTxExtensionMethods;

export function AuthzExtension<T extends {new (...args: any[]): BaseClient & AuthzExtension}>(constructor: T): T {
  return class extends AuthzTxExtension(AuthzQueryExtension(constructor)) {};
}

export * from "./amino";
export * from "./query";
export * from "./tx";
